// Système de couleurs — cœur de l'application. Source unique de vérité (légende).
// COLOR_ORDER : couleurs évaluées, utilisées pour les niveaux (bleu = 5 … rouge = 1).
export const COLOR_ORDER = ["blue", "green", "yellow", "orange", "red"];

// Cycle de clic (⚪ → 🔵 → 🟢 → 🟡 → 🟠 → 🔴 → ⚪) et ordre d'affichage de la légende.
export const CYCLE_ORDER = ["white", "blue", "green", "yellow", "orange", "red"];
export const LEGEND_ORDER = CYCLE_ORDER;

// Texte d'explication affiché au-dessus de la légende (écrans famille).
export const LEGEND_INTRO =
  "Les couleurs représentent le niveau observé cette semaine. Elles permettent de suivre les progrès de votre enfant et d'identifier les points à renforcer.";

export const COLOR_META = {
  white: {
    label: "Non évalué",
    meaning: "Non évalué (absence ou présence insuffisante)",
    cell: "bg-white hover:bg-slate-100 border border-slate-300",
    dot: "bg-white border border-slate-300",
  },
  blue: {
    label: "Bleu",
    meaning: "Très satisfaisant",
    cell: "bg-sky-400 hover:bg-sky-500",
    dot: "bg-sky-400",
  },
  green: {
    label: "Vert",
    meaning: "Satisfaisant",
    cell: "bg-emerald-400 hover:bg-emerald-500",
    dot: "bg-emerald-400",
  },
  yellow: {
    label: "Jaune",
    meaning: "En cours d'acquisition",
    cell: "bg-amber-300 hover:bg-amber-400",
    dot: "bg-amber-300",
  },
  orange: {
    label: "Orange",
    meaning: "À renforcer",
    cell: "bg-orange-400 hover:bg-orange-500",
    dot: "bg-orange-400",
  },
  red: {
    label: "Rouge",
    meaning: "À travailler en priorité",
    cell: "bg-rose-500 hover:bg-rose-600",
    dot: "bg-rose-500",
  },
};

// Niveau numérique pour les graphiques (bleu = 5 … rouge = 1).
// Blanc / inconnu => null : IGNORÉ dans les graphiques et statistiques.
export function colorToLevel(color) {
  const i = COLOR_ORDER.indexOf(color);
  return i === -1 ? null : COLOR_ORDER.length - i;
}

export function levelToColor(level) {
  return COLOR_ORDER[COLOR_ORDER.length - level] || "blue";
}
